export default "__VITE_ASSET__BZ8T6kmi__"